import React, { useEffect } from 'react';
import Blog from './Blog';

const BlogList = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <Blog />;
};

export default BlogList;
